import { lazy } from 'react';

export const AddUser = lazy(() => import('./user/AddUser'));
export const UserList = lazy(() => import('./user/UserList'));
export const UpdateUser = lazy(() => import('./user/UpdateUser'));

